import { render } from "./DashboardFilters.vue?vue&type=template&id=b39bddc6"
import script from "./DashboardFilters.vue?vue&type=script&lang=js"
export * from "./DashboardFilters.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__